export default __webpack_public_path__ + "static/img_red-ribbon-2919dcf6eb7e6c17766e2c7840a812a8.png";